import React from 'react';
import './RestaurantReportPreview.css';

const RestaurantReportPreview: React.FC<{
  html: string | null;
  title: string;
  onClose: () => void;
}> = ({ html, title, onClose }) => html === null ? null : <section className="restaurant-report-preview">
  <h3>Попередній перегляд</h3>
  <button type="button" onClick={onClose}>Закрити перегляд</button>
  <iframe title={title} sandbox="" srcDoc={html} />
</section>;

export default RestaurantReportPreview;
